import { render } from "./custom-goods.vue?vue&type=template&id=70d333a6"
import script from "./custom-goods.vue?vue&type=script&lang=js"
export * from "./custom-goods.vue?vue&type=script&lang=js"

import "./custom-goods.vue?vue&type=style&index=0&id=70d333a6&lang=scss"
script.render = render

export default script